import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.anfd__setFirstDash__title),
  helpCenter: () => i18n.t(i18nKeys.anfd__action__helpCenter),
  dashNowLabel: () => i18n.t(i18nKeys.common__dashNow),
  scheduleLaterLabel: () => i18n.t(i18nKeys.common__scheduleForLater),
  schedule: {
    content1: () => i18n.t(i18nKeys.anfd__page__topDasher__content_1),
    content2: () => i18n.t(i18nKeys.anfd__page__topDasher__content_2),
    content3: () => i18n.t(i18nKeys.anfd__page__topDasher__content_3),
  },
  busy: {
    content1: () => i18n.t(i18nKeys.anfd__page__dashNow__content_1),
  },
  scheduleFirstDash: {
    content1: () => i18n.t(i18nKeys.anfd__page__schedule__content_1),
    content2: () => i18n.t(i18nKeys.anfd__page__schedule__content_2),
  },
  noStartingPoint: {
    content1: () => i18n.t(i18nKeys.anfd__page__schedule__noStartingPoint_1),
    content2: () => i18n.t(i18nKeys.anfd__page__schedule__noStartingPoint_2),
    content3: () => i18n.t(i18nKeys.anfd__page__schedule__noStartingPoint_3),
  },
}
